<template>
    <b-card>
        <b-row class="ml-1 mt-4 mb-4">
            <b-col/>
            <b-col class="justify-content-end" md="auto">
                <b-button v-on:click="submit" variant="primary" :disabled="lear_selected.length === 0" class="px-4 mr-3">Speichern</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col style="height:60vh; overflow: auto">
                <b-table striped hover selectable :items="legr" :fields="legr_fields"
                         select-mode="single"
                         selectedVariant="primary"
                         @row-selected="rowSelectedGroupLegr"
                ></b-table>
            </b-col>
            <b-col style="height: 60vh; overflow: auto">
                <b-table striped hover :items="lear" :fields="lear_fields" selectable
                         select-mode="single"
                         selectedVariant="primary"
                         @row-selected="rowSelectedLear"></b-table>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
    import {Server_URL} from "../../shared/utils";

    export default {
        name: "DefaultTask",

        data() {
            return {
                currentLegr: {},
                legr: [],
                lear: undefined,
                legrMap: {},
                legr_fields: [{key: "schluessel", label: 'Leistungsgruppe'}],
                lear_fields: [{key: "schluessel", label: 'Leistungsart'}],
                lear_selected: [],
                lear_name: ""
            }
        },
        mounted() {
            this.showLoader();
            this.$http.get(
                Server_URL+'/baumkontrolle/config/schluessel_lear'
            ).then(this.responseOkGet, this.responseError)
        },
        methods: {
            rowSelectedGroupLegr(items) {
                if (items.length === 0) {
                    this.lear = undefined;
                    this.lear_selected = [];
                    this.currentLegr = {};
                } else {
                    this.lear = this.legrMap[items[0].schluessel];
                    this.currentLegr = items[0];
                    this.lear_selected = [];
                }
            },
            rowSelectedLear(items) {
                this.lear_selected = items;
            },
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    console.log(response);
                    this.legr = response.body.legr;
                    this.legrMap = response.body.legr_map;
                } else {
                    console.log(response);
                }
            },
            responseOk(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.$router.go(-1);
                } else {
                    console.log(response);
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            submit() {
                this.showLoader();
                this.$http.post(
                    Server_URL+'/baumkontrolle/bk_settings',
                    [{
                        id: "timetracking_lear",
                        value: this.currentLegr.wert + "||" + this.lear_selected[0].wert + "||" + this.lear_selected[0].schluessel
                    }]
                ).then(this.responseOk, this.responseError);
            }
        }
    }
</script>

<style>
    .black {
        color: #000;
    }
</style>
<style scoped>

</style>
